import banks from '@/assets/banks.json';


let bankList = [];
for (let bank of banks) {
  bankList.push({
    label: bank,
    logo: require('@/assets/bank/' + bank + '.png'),
    value: bank
  });
}

export {
  bankList,
};